(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonios"] && !Shopify.designMode) return;
  try {
    
 const initTestimonials = () => {
    document.querySelectorAll('[data-home-testimonials]').forEach(section => {
      const viewport = section.querySelector('[data-testimonials-viewport]');
      const track = section.querySelector('[data-testimonials-track]');
      const nextBtn = section.querySelector('[data-testimonials-next]');
      const prevBtn = section.querySelector('[data-testimonials-previous]');
      const dotsContainer = section.querySelector('[data-testimonials-pagination]');
      
      const autoRotate = section.dataset.autoRotate === 'true';
      const intervalTime = parseInt(section.dataset.interval) || 6000;
      let scrollInterval = null;

      const updateControls = () => {
        const index = Math.round(viewport.scrollLeft / viewport.offsetWidth);
        const currentPageElem = section.querySelector('[data-current-page]');
        if (currentPageElem) currentPageElem.textContent = index + 1;
        
        section.querySelectorAll('.home-testimonials-orbit__dot').forEach((dot, i) => {
          dot.setAttribute('aria-current', i === index);
        });
      };

      const scrollToIndex = (index) => {
        viewport.scrollTo({
          left: index * viewport.offsetWidth,
          behavior: 'smooth'
        });
      };

      const moveNext = () => {
        const maxScroll = track.scrollWidth - viewport.offsetWidth;
        if (viewport.scrollLeft >= maxScroll - 10) {
          viewport.scrollTo({left: 0, behavior: 'smooth'});
        } else {
          viewport.scrollBy({left: viewport.offsetWidth, behavior: 'smooth'});
        }
      };

      const startAutoScroll = () => {
        if (autoRotate && !scrollInterval) {
          scrollInterval = setInterval(moveNext, intervalTime);
        }
      };

      const stopAutoScroll = () => {
        if (scrollInterval) {
          clearInterval(scrollInterval);
          scrollInterval = null;
        }
      };

      nextBtn?.addEventListener('click', () => {
        stopAutoScroll();
        moveNext();
        startAutoScroll();
      });

      prevBtn?.addEventListener('click', () => {
        stopAutoScroll();
        viewport.scrollBy({left: -viewport.offsetWidth, behavior: 'smooth'});
        startAutoScroll();
      });

      const setupDots = () => {
        const slidesCount = Math.ceil(track.scrollWidth / viewport.offsetWidth);
        const totalPagesElem = section.querySelector('[data-total-pages]');
        if (totalPagesElem) totalPagesElem.textContent = slidesCount;
        
        dotsContainer.innerHTML = '';
        if (slidesCount > 1) {
          for (let i = 0; i < slidesCount; i++) {
            const dot = document.createElement('button');
            dot.classList.add('home-testimonials-orbit__dot');
            dot.setAttribute('type', 'button');
            dot.addEventListener('click', () => {
              stopAutoScroll();
              scrollToIndex(i);
              startAutoScroll();
            });
            dotsContainer.appendChild(dot);
          }
        }
      };

      section.addEventListener('mouseenter', stopAutoScroll);
      section.addEventListener('mouseleave', startAutoScroll);
      section.addEventListener('focusin', stopAutoScroll);
      section.addEventListener('focusout', startAutoScroll);

      viewport.addEventListener('scroll', updateControls);
      
      setupDots();
      updateControls();
      startAutoScroll();

      window.addEventListener('resize', setupDots);
    });
  };

  document.addEventListener('DOMContentLoaded', initTestimonials);
  document.addEventListener('shopify:section:load', initTestimonials);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initTestimonials();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-product-testimonios"] && !Shopify.designMode) return;
  try {
    
  const initRptCarousels = () => {
    document.querySelectorAll('[data-rpt].rpt--carousel').forEach(section => {
      const viewport = section.querySelector('[data-rpt-viewport]');
      const track = section.querySelector('[data-rpt-track]');
      const nextBtn = section.querySelector('[data-rpt-next]');
      const prevBtn = section.querySelector('[data-rpt-prev]');
      const dots = section.querySelector('[data-rpt-dots]');
      if (!viewport || !track) return;

      const autoRotate = section.dataset.autoRotate === 'true';
      const interval = parseInt(section.dataset.interval) || 6000;
      let timer = null;

      const pages = () => Math.max(1, Math.ceil(track.scrollWidth / viewport.offsetWidth));
      const current = () => Math.round(viewport.scrollLeft / viewport.offsetWidth);

      const update = () => {
        const i = current();
        const c = section.querySelector('[data-rpt-current]');
        if (c) c.textContent = i + 1;
        if (dots) dots.querySelectorAll('button').forEach((d, x) => d.setAttribute('aria-current', x === i));
      };
      const go = (i) => viewport.scrollTo({ left: i * viewport.offsetWidth, behavior: 'smooth' });
      const moveNext = () => {
        const max = track.scrollWidth - viewport.offsetWidth;
        if (viewport.scrollLeft >= max - 10) go(0);
        else viewport.scrollBy({ left: viewport.offsetWidth, behavior: 'smooth' });
      };
      const start = () => { if (autoRotate && !timer) timer = setInterval(moveNext, interval); };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

      nextBtn && nextBtn.addEventListener('click', () => { stop(); moveNext(); start(); });
      prevBtn && prevBtn.addEventListener('click', () => { stop(); viewport.scrollBy({ left: -viewport.offsetWidth, behavior: 'smooth' }); start(); });

      const build = () => {
        const n = pages();
        const t = section.querySelector('[data-rpt-total]');
        if (t) t.textContent = n;
        if (dots) {
          dots.innerHTML = '';
          if (n > 1) for (let i = 0; i < n; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'rpt__dot';
            b.setAttribute('aria-label', 'Ir a slide ' + (i + 1));
            b.addEventListener('click', () => { stop(); go(i); start(); });
            dots.appendChild(b);
          }
        }
      };

      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      viewport.addEventListener('scroll', update);

      build(); update(); start();
      window.addEventListener('resize', () => { build(); update(); });
    });
  };

  document.addEventListener('DOMContentLoaded', initRptCarousels);
  document.addEventListener('shopify:section:load', initRptCarousels);
  if (document.readyState === 'complete' || document.readyState === 'interactive') initRptCarousels();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["semana-aniversario"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSpotlights() {
      document.querySelectorAll('[data-sa-testimonials]').forEach(function (root) {
        if (root.dataset.saInit === '1') return;
        var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sa-slide]'));
        root.dataset.saInit = '1';
        if (slides.length < 2) return;

        var dotsWrap = root.querySelector('[data-sa-dots]');
        var prev = root.querySelector('[data-sa-prev]');
        var next = root.querySelector('[data-sa-next]');
        var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
        var current = 0;
        var timer = null;

        var dots = slides.map(function (_slide, idx) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sa-dot';
          dot.setAttribute('aria-label', 'Testimonio ' + (idx + 1));
          dot.addEventListener('click', function () { go(idx); restart(); });
          if (dotsWrap) dotsWrap.appendChild(dot);
          return dot;
        });

        function go(n) {
          current = (n + slides.length) % slides.length;
          slides.forEach(function (slide, idx) {
            var active = idx === current;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
          dots.forEach(function (dot, idx) {
            dot.setAttribute('aria-current', idx === current ? 'true' : 'false');
          });
        }
        function step() { go(current + 1); }
        function start() { if (!timer) timer = setInterval(step, interval); }
        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        function restart() { stop(); start(); }

        if (prev) prev.addEventListener('click', function () { go(current - 1); restart(); });
        if (next) next.addEventListener('click', function () { go(current + 1); restart(); });
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);

        go(0);
        start();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSpotlights);
    } else {
      initSpotlights();
    }
    document.addEventListener('shopify:section:load', initSpotlights);
  })();

  } catch(e) { console.error(e); }
})();
})();
